module.exports = __webpack_public_path__ + "img/landing-invest-ideas.9f7a56cf.svg";